import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";

function useAddMemberHook() {
  const [isLoading, setIsLoading] = useState(false);
  const [listData, setListData] = useState([]);
  const { employees, loading, error } = useSelector(
    (state) => state.employees_list
  );
  const [selected, setSelected] = useState(null);
  const [allData, setAllData] = useState([]);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentData, setCurrentData] = useState([]);

  const totalShow = 10;

  useEffect(() => {
    if (employees?.length) {
      setAllData(employees);
      setData(employees);
      setCurrentPage(1);
    }
  }, [employees]);

  useEffect(() => {
    _processData();
  }, [currentPage, data]);

  const _processData = () => {
    const from = (currentPage - 1) * totalShow;
    const to = Math.min(from + totalShow, data.length);
    setCurrentData(data.slice(from, to));
  };

  const handlePageChange = useCallback(
    (type) => {
      const newPage = type + 1;
      if (Math.ceil(data.length / totalShow) >= newPage) {
        setCurrentPage(newPage);
      }
    },
    [data, totalShow]
  );

  const handleValueChange = useCallback(
    (value) => {
      if (value) {
        const tempData = allData?.filter((val) => {
          return (
            val?.code?.match(new RegExp(value, "ig")) ||
            val?.name?.match(new RegExp(value, "ig"))
          );
        });
        setData(tempData);
        setCurrentPage(1);
      } else {
        setData(allData);
        setCurrentPage(1);
      }
    },
    [allData]
  );

  return {
    listData,
    handleValueChange,
    isLoading,
    selected,
    setSelected,
    currentPage,
    currentData,
    data,
    allData,
    handlePageChange,
    loading
  };
}

export default useAddMemberHook;
